import { Table } from "antd";
import "bootstrap-icons/font/bootstrap-icons.css";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";

import "./user.css";

function CustomTable({ list }) {
    const dispatch = useDispatch();
    const [status, setStatus] = useState("true");
    const [columnsToShow, setColumnsToShow] = useState([]);

    const { loading } = useSelector((state) => state.users);

    const columns = [
        {
            id: 1,
            title: "S.No",
            dataIndex: "serial",
            key: "serial",
        },
        {
            id: 2,
            title: "Name",
            key: "fullName",
            render: ({ firstName, lastName }) => (firstName + " " + lastName).toUpperCase(),
        },
        {
            id: 3,
            title: "Usr Name",
            dataIndex: "userName",
            key: "userName",
        },
        {
            id: 4,
            title: "Salary Start Date",
            dataIndex: "startDate",
            key: "startDate",
        },
        {
            id: 5,
            title: "Salary",
            dataIndex: "salary",
            key: "salary",
        },
    ];

    const onChange = (value) => {
        setStatus(value);
        dispatch(loadAllStaff({ status: value }));
    };

    useEffect(() => {
        setColumnsToShow(columns);
    }, []);

    const columnsToShowHandler = (val) => {
        setColumnsToShow(val);
    };

    // const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
  const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));


    const formatData = (data) => {
        return data.map(item => {
            const latestSalary = item.salaryHistory.length > 0 ? item.salaryHistory[0].salary : "N/A";
            const startDate = item.designationHistory.length > 0 ? item.designationHistory[0].startDate : "N/A";
            const formattedStartDate = startDate !== "N/A" ? moment(startDate).format("DD-MM-YYYY") : "N/A";
            return {
                ...item,
                salary: latestSalary,
                startDate: formattedStartDate
            };
        });
    };

    return (
        <div className='ant-card p-4 rounded mt-5'>
            <div className='flex my-2 justify-between'>
                <div className='w-50'>
                    <h4 className='text-2xl mb-2'>Total Salary List</h4>
                </div>
            </div>
            {list && (
                <div style={{ marginBottom: "30px" }}>
                    <ColVisibilityDropdown
                        options={columns}
                        columns={columns}
                        columnsToShowHandler={columnsToShowHandler}
                    />
                </div>
            )}
            <Table
                scroll={{ x: true }}
                loading={loading}
                pagination={{
                    defaultPageSize: 20,
                }}
                columns={columnsToShow}
                dataSource={list ? addKeys(formatData(list)) : []}
            />
        </div>
    );
}

const GetTotalSalary = (props) => {
    const dispatch = useDispatch();
    const list = useSelector((state) => state.users.list);

    useEffect(() => {
        dispatch(loadAllStaff({ status: "true" }));
    }, []);

    return (
        <UserPrivateComponent permission={"readAll-user"}>
            <div className='card card-custom'>
                <div className='card-body'>
                    <CustomTable list={list} />
                </div>
            </div>
        </UserPrivateComponent>
    );
};

export default GetTotalSalary;
